import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEligibleForStandardToPremium } from './is-eligible-for-standard-to-premium';

export function isEligibleForJWMExperiment(context: EditionAwarenessContextType): boolean {
	const {
		product,
		originalProjectTypeWasCore,
		isInCollection,
		userRoles,
		edition,
		isInTrial,
		isInPredunning,
		canUpgrade,
		canDirectBuyUpgrade,
		invoiceableStatus,
		canAddPaymentDetails,
	} = context;

	// Base checks for this experiment
	if (product === 'jira' && originalProjectTypeWasCore) {
		// Had to replicate from audience-and-timing to avoid having to expose this experiment on each modal that targets Jira
		const isInTrialOrPredunning = isInTrial || isInPredunning;

		const collectionWithPermissions =
			isInCollection === 'IN_COLLECTION' &&
			userRoles?.includes('BILLING_ADMIN') &&
			(edition === 'free' || isInTrialOrPredunning);
		const freeEditionWithPermissions =
			isInCollection === 'NOT_IN_COLLECTION' &&
			edition === 'free' &&
			(canUpgrade || canDirectBuyUpgrade);
		const trialWithPermissions =
			isInCollection === 'NOT_IN_COLLECTION' &&
			(edition === 'standard' || edition === 'premium') &&
			isInTrialOrPredunning &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails;
		const standardToPremium = isEligibleForStandardToPremium(context);

		return Boolean(
			collectionWithPermissions ||
			freeEditionWithPermissions ||
			trialWithPermissions ||
			standardToPremium,
		);
	}
	return false;
}
